const STATUSES = {
  ENABLED: 'enabled',
  DISABLED: 'disabled',
}

const OWNED_BY = {
  COLLABORATOR: 'collaborator',
  ORGANIZATION: 'organization',
  COMPANY: 'company',
}

const GROUP_MANAGEABLE = {
  UNIFIED: 'unified',
  PER_SOLUTION: 'per_solution',
}

const SOLUTION_MANAGEABLE = {
  INDIVIDUAL: 'individual',
  GROUP_ONLY: 'group_only',
}

const GROUP_TAGS = {
  GOVERNANCE_PROJECTS: 'governance_projects_group',
}

const TAGS = {
  DAI_CHAT_PLATFORM: 'dai_chat_platform',
  GENERATE_PLAN_ACTION: 'generate_plan_action',
  GOVERNANCE_PROJECT_ACTIVITY_ANALYSIS: 'governance_project_activity_analysis',
  GOVERNANCE_PROJECT_EVIDENCE_ANALYSIS: 'governance_project_evidence_analysis',
  GOVERNANCE_PROJECT_DISPUTE_ANALYSIS: 'governance_project_dispute_analysis',
  PRE_CONTRACT_ANALYSIS: 'pre_contract_analysis',
  POP_CREATION: 'pop_creation',
  DOCUMENT_CREATION: 'document_creation',
  GENERATE_DATA_PROCESS_TREATMENT_PLAN_ACTION:
    'generate_data_process_treatment_plan_action',
  AI_INVENTORY: 'ai_inventory',
}

export default {
  GROUP_TAGS,
  TAGS,
  STATUSES,
  OWNED_BY,
  GROUP_MANAGEABLE,
  SOLUTION_MANAGEABLE,
}
